import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  Dialog, // Import Dialog
  DialogTitle, // Import DialogTitle
  DialogContent, // Import DialogContent
  DialogActions, // Import DialogActions
} from '@mui/material'; // Import necessary components
import { useDropzone } from 'react-dropzone';

export function ImportLogsDialog({ open, onClose, projectId, serverUrl, token, fetchProjects, onMessage, onError}) {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'text/csv': ['.csv'],
    },
    maxFiles: 1,
  });

  const handleUpload = async () => {
    if (!file) {
      onError('Please select a file to upload.');
      return;
    }

    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);

      await axios.post(`${serverUrl}/projects/${projectId}/import`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      onMessage('Logs imported successfully!');
      fetchProjects(); // Refresh project data
      onClose();
    } catch (err) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Error importing logs';
      onError(`Error importing logs: ${errorMessage}`)
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Import Logs</DialogTitle>
      <DialogContent>
        <Box {...getRootProps()} sx={{ border: '2px dashed #ccc', p: 4, textAlign: 'center', cursor: 'pointer' }}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <Typography>Drop the file here ...</Typography>
          ) : (
            <Typography>Drag 'n' drop a CSV file here, or click to select a file</Typography>
          )}
          {file && (
            <Typography sx={{ mt: 2 }}>
              Selected file: {file.name} ({file.size} bytes)
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleUpload} disabled={!file || isUploading}>
          {isUploading ? 'Uploading...' : 'Upload'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
